import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IKioskMessage, IKIOSKModel } from '../../../../models/kioskModel';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const ThankYoupage: React.FC = () => {
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const authFailMessage: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.authFailMessage || "");
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    const messgageObj: any = kioskConfigMsgs?.find((x) => (x?.msgValueEn === authFailMessage) || (x?.msgValueAr === authFailMessage)) || undefined;
    const message: string = (language === Ilanguages.ENG) ? messgageObj?.msgValueEn : messgageObj?.msgValueAr;
    console.log("checkauthmessage=>", authFailMessage, message);
    return (
        <div className='d-flex flex-column align-items-center justify-content-center gap-4 thank_msg text-center'>
            <i className='icon_m42kiosk_registration_desk'></i>
            {authFailMessage === 'EM0' && <span>{t('errorMessage.EM1' + language)}<br /> {t('errorMessage.EM2' + language)}</span>}
            {authFailMessage !== 'EM0' && <p>{message || authFailMessage}</p>}
            <span>{(getLabelConfigMsg(kioskConfigMsgs, language, "thankYou") || t("kiosktranslation.thankYou" + language))}</span>
        </div>
    );
}

export default React.memo(ThankYoupage);